import { render, staticRenderFns } from "./couponAudit.vue?vue&type=template&id=4be94c2a&scoped=true"
import script from "./couponAudit.vue?vue&type=script&lang=js"
export * from "./couponAudit.vue?vue&type=script&lang=js"
import style0 from "./couponAudit.vue?vue&type=style&index=0&id=4be94c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be94c2a",
  null
  
)

export default component.exports